import {Component, tag} from 'doz'
import rssParser from 'rss-parser'
import logoUrlRect from '../../resources/default-cover.png'

const EXCLUDE_POSSIBLE_EXTENSIONS_REGEX = /\.(mp3|mp4|wav)/gi;
const EXCLUDE_ENCLOSURE_REGEX = /(audio|video)\//;

@tag('news')
export default class extends Component {
    props = {
        //feedUrl: '',
        feed:[],
        //maxFeed: 5,
        defaultCoverUrl: logoUrlRect
    };

    template(h) {
        //language=HTML
        return h`
            <style>
                .container{
                    color: ${this.THEME.primaryColor};
                    background: ${this.PLAYER_CONFIG.newsBackgroundColor || this.THEME.onPrimaryColor};
                    border-color: ${this.PLAYER_CONFIG.newsSeparatorColor || ''};
                    text-align:left;
                    min-height: 900px;
                }
                
                .img{
                    width: 100%;
                    height: 150px;
                    object-fit: cover;
                    object-position: top;
                    border-radius: 8px;
                }
                
                .masked{
                    clip-path: polygon(0 0, 100% 0, 100% calc(100% - 30px), 0 100%);
                    -webkit-clip-path: polygon(0 0, 100% 0, 100% calc(100% - 30px), 0 100%);
                }
                   
                .row {
                    border-bottom: 1px dotted ${this.PLAYER_CONFIG.newsArticleSeparatorColor || this.THEME.primaryColorDark};
                    padding: 24px 0;
                }
                
                .row:nth-child(1) {
                    padding-top: 0 !important;
                }
                
                .row:nth-child(2) {
                    padding-top: 24px !important;
                }
                
                .row:last-child {
                    border: none;
                    padding-bottom: 0;
                }
                
                .layout-horizontal.row{
                    display: flex;
                } 
                
                .layout-horizontal.row .img{
                    width: 100px;
                    height: 100px;
                    margin-right: 16px;
                } 
                
                .layout-horizontal.row p{
                    font-size: 14px;
                } 
                
                .date {
                    font-size: 11px; 
                    color:${this.PLAYER_CONFIG.newsArticleDateColor || this.THEME.primaryColorDark}; 
                    text-transform: capitalize;
                }
                
                .title {
                    margin: 3px 0; 
                    font-size: 20px; 
                    color: ${this.PLAYER_CONFIG.newsArticleTitleColor || this.THEME.primaryColor};
                }
                
                .link {
                    color: ${this.PLAYER_CONFIG.newsArticleLinkColor || this.THEME.primaryColorDark}; 
                    text-decoration: none; 
                    font-size: 11px;
                }
                
                h3 {
                    color: ${this.PLAYER_CONFIG.newsTitleColor || this.THEME.primaryColor};
                }
                
                .content {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
            </style>
            <div class="container">
                <h3>${this.PLAYER_CONFIG.newsTitleText || 'News'}</h3>
                <div> 
                    ${this.each(this.props.feed,item =>h`
                        <div class="row animated fadeIn ${this.PLAYER_CONFIG.newsFeedType === 'LAYOUT_2' ? 'layout-horizontal' : ''}">
                            <a href="${item.link}" target="_blank">
                                <img loading="lazy" d-show="${!!item.enclosure.url}" class="img" src="${item.enclosure.url || this.props.defaultCoverUrl}">
                            </a>
                            <div class="content">
                                <span class="date">
                                    ${new Date(item.isoDate).toLocaleDateString('it-IT', {year: 'numeric', month: 'long',day: 'numeric'})}
                                </span>
                                <p class="title">${item.title}</p>
                                <a class="link" href="${item.link}" target="_blank">Leggi di più</a>
                            </div>
                        </div>
                     `)}
                </div>    
            </div>
        `
    }

    onMount(){
        this.getFeed();
        if (!this.isSSR())
            setInterval(() => this.getFeed(),60000 * 5);
    }

    getFeed(){
        let count = 0;

        if (!this.PLAYER_CONFIG.newsFeedUrl) return;

        let parser = new rssParser({
            customFields: {
                item: [
                    ['media:thumbnail', 'thumbnail']
                ]
            }
        });

        parser.parseURL(this.CORS_PROXY + this.PLAYER_CONFIG.newsFeedUrl, (err, feed) => {
            if (err) throw err;
            // console.log(feed);
            //this.props.feed = feed.items;
            this.props.feed = [];
            feed.items.forEach((entry) => {
                // console.log(entry.thumbnail)
                if (!entry.enclosure && entry.thumbnail && entry.thumbnail.$ && entry.thumbnail.$.url) {
                    entry.enclosure = {
                        url: entry.thumbnail.$.url
                    }
                }
                if(count < 5){
                    if(!entry.enclosure){
                        entry.enclosure = {
                            url: this.getFeedImg(entry)
                        };
                    }

                    //console.log(entry.enclosure.url, EXCLUDE_POSSIBLE_EXTENSIONS_REGEX.test(entry.enclosure.url))

                    if(EXCLUDE_POSSIBLE_EXTENSIONS_REGEX.test(entry.enclosure.url) || EXCLUDE_ENCLOSURE_REGEX.test('' + entry.enclosure.type))
                        return;

                    this.props.feed.push(entry);
                    count++;
                }
            });
        });
    }

    goToNews(link){
        window.open(link,'_blank');
    }

    /*
    getFeedImg(feed){
        let content = feed.content.split('src="');
        if(content[1]){
            let src = content[1].split('"');
            if(src[0]){
                return src[0];
            }else{
                return ''
            }
        }
    }
     */

    getFeedImg(feed){
        let match = null;
        let content = feed['content:encoded'] || feed['content'];
        if (content) {
            match = content.match(/<img.*src=["'](.*?)["']/i)
        }
        if(match && match[1]){
            return match[1]
        } else
            return ''
    }

}
